/* eslint-disable no-param-reassign */
import Vue from 'vue';
import baseURL from '@/api/http-common';
import router from '@/router';

let userObj = ((localStorage.getItem('telasUserObj') !== null) && (localStorage.getItem('telasUserObj').length > 0)) ? JSON.parse(localStorage.getItem('telasUserObj')) : '';
const dashboard = {
  courseSubmitterList: [],
  adminReviewersList: [],
  interimReviewersList: [],
  certifiedReviewersList: [],
  userRequestsList: [],
  userDetails: {},
  userDetailsById: {},
  courseSubmitterCourses: {},
  courses: {
    allCourses: [],
    insitutionsCourses: [],
    courseSubmitterCourses: {
      approved: [],
    },
    assessorsCourses: {
      assigned: [],
    },
    telasAdminCourses: {
      submitted: [],
      inProgress: [],
      completed: [],
      testCourses: [],
    },
  },
};

const getters = {
  getCourseSubmitters: state => state.courseSubmitterList,
  getUserProfileDetails: state => state.userDetails,
  getAdminReviewers: state => state.adminReviewersList,
  getInterimReviewers: state => state.interimReviewersList,
  getCertifiedReviewers: state => state.certifiedReviewersList,
};

const actions = {
  async getUsers({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      const response = await Vue.axios.get(`${baseURL}extended-telasweb/v1/telas-users?per_page=100`, { params: data });
      const actualData = response.data;
      commit('GETUSERS', { actualData, rootState, data });
    } catch (error) {
      if (error) {
        const actualData = error.response.data;
        const origin = 'login';
        commit('GETUSERSERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async getUserDetail({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      data.user_id = data.user_id === undefined ? userObj.user_id : data.user_id;
      const response = await Vue.axios.get(`${baseURL}extended-telasweb/v1/telas-user`, { params: data });
      const actualData = response.data;
      commit('GETUSERDETAIL', { actualData, rootState, data });
    } catch (error) {
      if (error) {
        const actualData = error.response.data;
        const origin = 'getUserDetail';
        commit('GETUSERERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async getCoursesByUser({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      userObj = rootState.user.userDetails.length > 0 ? rootState.user.userDetails : userObj;
      // eslint-disable-next-line prefer-destructuring
      const response = await Vue.axios.get(`${baseURL}wp/v2/telas-courses?per_page=100`, {
        params: data,
      });
      const actualData = response.data;
      switch (data.role) {
        case 'telas_course_submitters':
          commit('GETCOURSESUBMITTERSCOURSES', { actualData, data });
          break;
        case 'assessors':
          commit('GETASSESSORSCOURSES', { actualData, data });
          break;
        case 'tela-admin':
          commit('GETTELASADMINCOURSES', { actualData, data });
          break;
        case 'all':
          commit('GETALLCOURSES', { actualData, data });
          break;
        case 'institution':
          commit('GETCOURSESOFANINSTITUTION', { actualData, data });
          break;
        default:
          commit('GETCOURSESUBMITTERSCOURSES', { actualData, data });
          break;
      }
    } catch (error) {
      if (error) {
        const actualData = error.response.data;
        const origin = 'getCourses';
        commit('HANDLEERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async getUserByMeta({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      userObj = rootState.user.userDetails.length > 0 ? rootState.user.userDetails : userObj;
      const { userToken } = data;
      const response = await Vue.axios.get(`${baseURL}wp/v2/users?per_page=100`, {
        params: data,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      const actualData = response.data;
      switch (data.tab) {
        case 'userRequests':
          commit('USERREQUESTS', { actualData, rootState });
          break;
        case 'adminReviewers':
          commit('ADMINREVIEWERS', { actualData, rootState });
          break;
        case 'courseSubmitters':
          commit('COURSESUBMITTERS', { actualData });
          break;
        case 'interimReviewers':
          commit('INTERIMREVIEWERS', { actualData });
          break;
        case 'certifedReviewers':
          commit('CERTIFIEDREVIEWERS', { actualData });
          break;
        default:
          commit('USERREQUESTS', { actualData, rootState });
          break;
      }
    } catch (error) {
      if (error) {
        const actualData = error.response.data;
        const origin = 'getUserByMeta';
        commit('HANDLEERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async getUserProfileByID({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      const response = await Vue.axios.get(`${baseURL}extended-telasweb/v1/telas-user`, { params: data });
      const actualData = response.data;
      commit('GETUSERPROFILEBYID', { actualData });
    } catch (error) {
      if (error) {
        const actualData = error.response.data;
        const origin = 'getUserDetail';
        commit('GETUSERERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async userApproveAction({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      userObj = rootState.user.userDetails.length > 0 ? rootState.user.userDetails : userObj;
      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(`${baseURL}extended-telasweb/v1/user-actions`, data, options);
      const actualData = response.data;
      commit('USERACTION', { actualData });
    } catch (error) {
      if (error) {
        console.log(error.response.data);
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async deleteUser({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      userObj = rootState.user.userDetails.length > 0 ? rootState.user.userDetails : userObj;
      const { userToken } = data;
      const request = Vue.axios.create({
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      const response = await request.delete(`${baseURL}wp/v2/users/${data.user_id}`, { params: data });
      const actualData = response.data;
      commit('DELETEUSER', { actualData });
    } catch (error) {
      console.log('here');
    }
    commit('ENDLOADING', { rootState });
  },
};

const mutations = {
  GETUSERS(state, { actualData, rootState, data }) {
    if (data.role === 'telas_course_submitters') {
      dashboard.courseSubmitterList = actualData;
      rootState.common.messages.errors = '';
    }
  },
  GETUSERSERROR(state, { actualData, rootState }) {
    rootState.common.messages.errors = actualData;
  },
  GETUSERDETAIL(state, { actualData, rootState }) {
    dashboard.userDetails = actualData;
    rootState.common.messages.errors = '';
  },
  // eslint-disable-next-line no-unused-vars
  GETCOURSESUBMITTERSCOURSES(state, { actualData, data }) {
    dashboard.courses.courseSubmitterCourses.approved = actualData;
  },
  // eslint-disable-next-line no-unused-vars
  GETCOURSESOFANINSTITUTION(state, { actualData, data }) {
    dashboard.courses.insitutionsCourses = actualData;
  },
  // eslint-disable-next-line no-unused-vars
  GETASSESSORSCOURSES(state, { actualData, data }) {
    dashboard.courses.assessorsCourses.assigned = actualData;
  },
  // eslint-disable-next-line no-unused-vars
  GETTELASADMINCOURSES(state, { actualData, data }) {
    switch (data.progress) {
      case 'submitted':
        dashboard.courses.telasAdminCourses.submitted = actualData;
        break;
      case 'in-progress':
        dashboard.courses.telasAdminCourses.inProgress = actualData;
        break;
      case 'completed':
        dashboard.courses.telasAdminCourses.completed = actualData;
        break;
      case 'test-courses':
        dashboard.courses.telasAdminCourses.testCourses = actualData;
        break;
      default:
        break;
    }
  },
  // eslint-disable-next-line no-unused-vars
  GETALLCOURSES(state, { actualData, data }) {
    dashboard.courses.allCourses = actualData;
  },
  HANDLEERROR(state, { actualData, rootState, data }) {
    console.log(state, actualData, rootState, data);
  },
  // eslint-disable-next-line no-unused-vars
  USERREQUESTS(state, { actualData, rootState }) {
    state.userRequestsList = actualData;
  },
  ADMINREVIEWERS(state, { actualData }) {
    state.adminReviewersList = actualData;
  },
  INTERIMREVIEWERS(state, { actualData }) {
    state.interimReviewersList = actualData;
  },
  CERTIFIEDREVIEWERS(state, { actualData }) {
    state.certifiedReviewersList = actualData;
  },
  COURSESUBMITTERS(state, { actualData }) {
    state.courseSubmitterList = actualData;
  },
  GETUSERPROFILEBYID(state, { actualData }) {
    state.userDetailsById = actualData;
  },
  USERACTION(state, { actualData }) {
    state.userDetailsById = actualData;
  },
  DELETEUSER(state) {
    state.userDetailsById = {};
    router.replace({ path: '/dashboard/telas-user' });
  },
  LOADING(state, { rootState }) {
    rootState.common.loading = true;
  },
  ENDLOADING(state, { rootState }) {
    rootState.common.loading = false;
  },
};

export default {
  namespaced: true,
  state: dashboard,
  getters,
  actions,
  mutations,
};
